export const allowedFileFormats = [
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "text/csv",
];

export const allowedFileExtensions = ["xlsx", "csv"];
